// extracted by mini-css-extract-plugin
export default {"wrapper":"FieldWrapper-module--wrapper--ZMDnP","label":"FieldWrapper-module--label--Kow0V"};